<template>
  <div id="permit">
    <div class="item">
      <img
        class="item-img"
        @click="
          previewImg(
            'https://acdn.mulazim.com/wechat_mini/img/permit/permit1.jpg',
          )
        "
        src="https://acdn.mulazim.com/wechat_mini/img/permit/permit1.jpg"
      />
    </div>
    <div class="item">
      <img
        class="item-img"
        @click="
          previewImg(
            'https://acdn.mulazim.com/wechat_mini/img/permit/permit2.jpg',
          )
        "
        src="https://acdn.mulazim.com/wechat_mini/img/permit/permit2.jpg"
      />
    </div>
    <div class="item">
      <img
        class="item-img"
        @click="
          previewImg(
            'https://acdn.mulazim.com/wechat_mini/img/permit/permit3.jpg',
          )
        "
        src="https://acdn.mulazim.com/wechat_mini/img/permit/permit3.jpg"
      />
    </div>
  </div>
</template>
<script>
export default {
  name: "permit",
  methods: {
    previewImg(urls) {
      this.$hevueImgPreview({ name: urls, url: urls });
    }
  }
};
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
}

#app {
  background: #f2f2f2;
}

.item {
  height: 100%;
  width: 100%;
}

.item-img {
  width: 100%;
  height: 100%;
}
</style>
